import React, { useEffect } from 'react'
import { Pattern } from '../pattern/Pattern';

const PatternGrid = ({ title, patterns, onClickPattern }) => {
    return (
        <div className="space-y-24">
            <h2 className="font-thin text-20 text-blue">{title}</h2>
            <div className="grid grid-cols-3 md:grid-cols-3 gap-20 scroll-container">
                {patterns.map((pattern) => (
                    <Pattern key={pattern.id} pattern={pattern} onClick={() => onClickPattern(pattern)} />
                ))}
            </div>
        </div>
    )
}


export default PatternGrid
